module.exports = __webpack_public_path__ + "static/media/S-task08_nodeLink.f3b42a5e.png";